export enum Permissions {
  ADMIN = 'admin',
  USER = 'user',
  EMPLOYEE = 'employee',
}
